import { render, staticRenderFns } from "./FastReply.vue?vue&type=template&id=6632b11c&scoped=true"
import script from "./FastReply.vue?vue&type=script&lang=js"
export * from "./FastReply.vue?vue&type=script&lang=js"
import style0 from "./FastReply.vue?vue&type=style&index=0&id=6632b11c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6632b11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6632b11c')) {
      api.createRecord('6632b11c', component.options)
    } else {
      api.reload('6632b11c', component.options)
    }
    module.hot.accept("./FastReply.vue?vue&type=template&id=6632b11c&scoped=true", function () {
      api.rerender('6632b11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consult/components/FastReply.vue"
export default component.exports